import { NodeProps } from '@xyflow/react';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CommonFlowCard, CommonFlowCardProps } from '@/lib/v3/components';

import { TRANSLATIONS } from '@/src/modules/AutomationModuleNew/constants/flows';

import { CalendarIcon } from '@/modules/AutomationModuleNew/icons';
import { TriggerNodeProps } from '@/modules/AutomationModuleNew/types/flowsTypes';

export const TriggerNode: FC<NodeProps<TriggerNodeProps>> = (props) => {
  const { t } = useTranslation();
  const { data } = props;

  const { icon, title, info, borderColor, id } = useMemo<CommonFlowCardProps>(() => {
    switch (data.type) {
      case 'upsertContact': {
        const { contact } = data.input;
        const { type, path } = contact;

        return {
          id: data.id,
          icon: <CalendarIcon />,
          title: t(TRANSLATIONS.nodeTypes.upsertContact),
          info: data.input.contact ? `Trigger: ${type} - ${path}` : undefined,
          borderColor: 'trigger',
        };
      }
    }
  }, [data.id, data.input, data.type, t]);

  return (
    <CommonFlowCard
      noTargetHandle
      borderColor={borderColor}
      icon={icon}
      id={id}
      info={info}
      title={title}
    />
  );
};
